import styled from 'styled-components';

import { Row } from '../../styles/align';
import { BtnGroup, Button } from '../../styles/forms';
// Styles
import { colors, fontSize } from '../../styles/variables';
import { Container } from '../style';

/**
 * Formata o Container da Modal de Confirmação de envio de arquivos
 *
 * @extends {Container}
 *
 * Herda estilo para formatar o interior do Container
 * @extends {Row}
 * @extends {BtnGroup}
 * @extends {Button}
 * @extends {colors}
 */
export const StyleDeliverySteps = styled(Container)`
  position: relative;
  background-color: ${colors.grey.light};
  padding: 1rem;

  .infoText {
    color: ${colors.error} !important;
  }

  ${Row} {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: ${colors.black.primary};

    p {
      align-self: left;
      color: ${colors.black.primary};
      padding: 1rem 0;
      line-height: 1.5;

      strong {
        font-weight: 700;
        color: ${colors.black.primary};
      }
    }

    span {
      align-self: center;
      font-size: ${fontSize.xl};
      font-weight: 700;
      color: ${colors.red.primary};
      margin: 1.25rem 0 1.25rem 0;
    }

    ${BtnGroup} {
      width: 100%;
      justify-content: flex-end;

      ${Button} {
        text-decoration: none;

        &:last-of-type {
          background-color: ${colors.primary};
          color: ${colors.default};
        }
      }
    }
  }
`;
